"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Form, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@dc/ui/components";
import { useTranslations } from "next-intl";
import { Controller } from "react-hook-form";
import { MESSAGE_MAX } from "./ContactSalesModal.schema";
import { useContactSales } from "./hooks/useContactSales";
import { useContactSalesForm } from "./hooks/useContactSalesForm";
export function ContactSalesModal() {
  const $ = _c(35);
  const t = useTranslations("contact_sales");
  const {
    isOpen,
    close
  } = useContactSales();
  const {
    form,
    onSubmit,
    isPending,
    messageRequired
  } = useContactSalesForm();
  const {
    formState: t0
  } = form;
  const {
    isSubmitting
  } = t0;
  const isCreating = isPending || isSubmitting;
  let t1;
  if ($[0] !== close) {
    t1 = open => {
      if (!open) {
        close();
      }
    };
    $[0] = close;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <ModalHeader>{t2}</ModalHeader>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== messageRequired || $[7] !== t) {
    t4 = t5 => {
      const {
        field: t6,
        fieldState
      } = t5;
      const {
        name,
        value,
        onChange,
        onBlur,
        ref
      } = t6;
      return <Textarea ref={ref} label={t("message_label")} placeholder={t(messageRequired ? "message_required_placeholder" : "message_optional_placeholder")} name={name} value={value || ""} onChange={onChange} onBlur={onBlur} isInvalid={!!fieldState.error} errorMessage={fieldState.error?.message} description={t("character_count", {
        count: value.length,
        max: MESSAGE_MAX
      })} minRows={4} maxRows={8} />;
    };
    $[6] = messageRequired;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== form.control || $[10] !== t4) {
    t5 = <ModalBody className="w-full gap-4"><Controller control={form.control} name="message" render={t4} /></ModalBody>;
    $[9] = form.control;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("cancel");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== close || $[15] !== isPending || $[16] !== t6) {
    t7 = <Button variant="bordered" color="secondary" size="sm" onPress={close} isDisabled={isPending}>{t6}</Button>;
    $[14] = close;
    $[15] = isPending;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("submit");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isCreating || $[21] !== t8) {
    t9 = <Button color="secondary" variant="solid" size="sm" type="submit" isDisabled={isCreating} isLoading={isCreating}>{t8}</Button>;
    $[20] = isCreating;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t9) {
    t10 = <ModalFooter className="w-full">{t7}{t9}</ModalFooter>;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== onSubmit || $[27] !== t10 || $[28] !== t3 || $[29] !== t5) {
    t11 = <ModalContent><Form onSubmit={onSubmit} validationBehavior="aria" className="flex min-h-0 flex-1 flex-col">{t3}{t5}{t10}</Form></ModalContent>;
    $[26] = onSubmit;
    $[27] = t10;
    $[28] = t3;
    $[29] = t5;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== isOpen || $[32] !== t1 || $[33] !== t11) {
    t12 = <Modal isOpen={isOpen} onOpenChange={t1} size="md" skipBack={true}>{t11}</Modal>;
    $[31] = isOpen;
    $[32] = t1;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}